import { formatFileSize } from '@shared/lib/format/file-size'
import { memberFileKind, memberFileKindLabel } from '../model/member-file'
import {
  documentAction,
  documentBody,
  documentCard,
  documentMark,
  documentMeta,
  documentTitle,
} from './member-access.css'

export function MemberFileCard({
  name,
  sizeBytes,
  contentType,
  ready = true,
  actionLabel,
  onOpen,
}: {
  name: string
  sizeBytes: number
  contentType?: string
  ready?: boolean
  actionLabel?: string
  onOpen?: () => void
}) {
  const kind = memberFileKind(name, contentType)
  const pending = !ready
  return (
    <button
      type="button"
      className={documentCard}
      data-testid="member-file-card"
      data-pending={pending ? 'true' : undefined}
      disabled={pending || !onOpen}
      onClick={onOpen}
    >
      <span className={documentMark({ kind })} aria-hidden>
        {memberFileKindLabel(kind)}
      </span>
      <span className={documentBody}>
        <span className={documentTitle}>{name}</span>
        <span className={documentMeta}>
          {pending
            ? 'O arquivo ainda não está pronto. Volte ao editor e envie de novo.'
            : `${memberFileKindLabel(kind)} · ${formatFileSize(sizeBytes)}`}
        </span>
      </span>
      <span className={documentAction}>
        {pending ? 'Aguardando' : (actionLabel ?? (kind === 'pdf' ? 'Abrir' : 'Baixar'))}
      </span>
    </button>
  )
}
